<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>活动管理</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入活动名称/编号"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">新增活动</el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport({
              'fpi-regex:title|string#or': searchValue,
              'fpi-regex:_id|string#or': searchValue,
              beanName: 'coupon',
              title: '活动管理列表'
            })
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    @click.native="
                      doRecord(scope.row._id);
                      openRecordDetail = true;
                    "
                  >
                    查看领取记录
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doStock(scope.row._id)">
                    修改发行量
                  </el-dropdown-item>

                  <el-dropdown-item
                    v-if="scope.row.state == 1 && osg.has(`Coupons,distribute`)"
                    @click.native="doDistribute(scope.row)"
                  >
                    发优惠券
                  </el-dropdown-item>

                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>

          <el-table-column label="活动名称" width="180px" prop="title" fixed>
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="$router.push({ path: `/Coupon/${scope.row._id}` })"
                type="text"
              >
                {{ scope.row.title }}
              </el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="code" label="优惠券编号" min-width="150px"></el-table-column> -->
          <el-table-column prop="state" label="状态">
            <template slot-scope="scope">
              <el-tag :type="scope.row.state == 1 ? '' : 'warning'">
                {{ scope.row.state == 1 ? '已启用' : '已禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="scopeType"
            label="优惠券适用范围类型"
            width="150"
            :formatter="formatterCouponType"
            show-overflow-tooltip
          ></el-table-column>
          <!-- 
          <el-table-column
            prop="scopeId"
            label="适用产品"
            width="170px"
            show-overflow-tooltip
            :formatter="formatterProductsList"
          ></el-table-column> -->
          <el-table-column prop="quantity" label="优惠券发行量" min-width="150px"></el-table-column>
          <el-table-column prop="stock" label="库存剩余数量" min-width="150px"></el-table-column>
          <el-table-column
            prop="exts.startDate"
            label="活动开始时间"
            min-width="180px"
            sortable
          ></el-table-column>
          <el-table-column
            prop="exts.endDate"
            label="活动结束时间"
            min-width="180px"
            sortable
          ></el-table-column>
          <el-table-column
            prop="startCouponDate"
            label="优惠券使用开始时间"
            min-width="180px"
            sortable
          ></el-table-column>
          <el-table-column
            prop="endCouponDate"
            label="优惠券使用结束时间"
            min-width="180px"
            sortable
          ></el-table-column>
          <!-- <el-table-column
            prop="duration"
            label="优惠券使用时长(天)"
            min-width="150px"
          ></el-table-column> -->
          <el-table-column
            prop="type"
            label="优惠券折扣类型"
            width="150"
            :formatter="formatterCpsDiscountType"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="price" label="购买价格" min-width="160px"></el-table-column>
          <el-table-column prop="value" label="优惠券面值" min-width="160px"></el-table-column>
          <el-table-column
            prop="prerequisites"
            label="使用条件"
            width="150"
            show-overflow-tooltip
          ></el-table-column>

          <!--   <el-table-column prop="eachDelivery" label="用户限领数量" min-width="160px"></el-table-column>  -->
          <el-table-column prop="description" label="描述" min-width="150px"></el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="活动信息" :visible.sync="openDetail">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="160px"
        label-position="left"
        hide-required-asterisk:true
      >
        <el-form-item label="活动名称" prop="title">
          <el-input v-model="formData.title"></el-input>
        </el-form-item>
        <!-- <el-form-item label="优惠券编号" prop="code">
          <el-input v-model="formData.code"></el-input>
        </el-form-item> -->

        <el-form-item label="优惠券适用范围类型" prop="scopeType">
          <el-select v-model="formData.scopeType" clearable @change="delete formData.scopeId">
            <el-option
              v-for="item in options.couponType"
              :key="item.value"
              :label="item.label"
              :value="+item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="$util.isShowField(formData, 'scopeType', 'scopeType', 1)"
          label="适用产品"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '适用产品不能为空'
          }"
          prop="scopeId"
        >
          <el-select v-model="formData.scopeId">
            <el-option
              v-for="item in ProductsList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!--
          <el-form-item label="可用用户类型" prop="scopeUser">
          <el-select v-model="formData.scopeUser">
            <el-option v-for="item in []" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        -->
        <!-- <el-form-item
          label="优惠券发行量"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '优惠券发行量不能为空'
          }"
          prop="quantity"
          v-if="!isEdit"
        >
          <el-input :min="0" type="number" v-model="formData.quantity"></el-input>
        </el-form-item> -->

        <!-- <el-form-item label="库存剩余数量" prop="stock">
          <el-input type="number" v-model="formData.stock"></el-input>
        </el-form-item>
        -->
        <!--
        <el-form-item label="是否随产品赠送" prop="giftWithProduct">
          <el-switch
            v-model="formData.giftWithProduct"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </el-form-item>
        -->
        <el-form-item
          label="活动时间"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '活动时间不能为空'
          }"
          prop="timeRange"
        >
          <el-date-picker
            v-model="formData.timeRange"
            type="datetimerange"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="优惠券使用时间"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '优惠券使用时间不能为空'
          }"
          prop="timeRange"
        >
          <el-date-picker
            v-model="formData.durationTimeRange"
            type="datetimerange"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          ></el-date-picker>
        </el-form-item>
        <!--
        <el-form-item
          label="优惠券使用时长(天)"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '优惠券使用时长不能为空'
          }"
          prop="duration"
        >
          <el-input type="number" v-model="formData.duration"></el-input>
        </el-form-item>
        -->
        <el-form-item
          label="购买价格"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '购买价格不能为空'
          }"
          prop="price"
        >
          <el-input :min="0" type="number" v-model="formData.price"></el-input>
        </el-form-item>
        <el-form-item
          label="优惠券折扣类型"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '优惠券折扣类型不能为空'
          }"
          prop="type"
        >
          <el-select v-model="formData.type">
            <el-option
              v-for="item in options.CpsDiscountType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <template
          v-if="
            $util.isShowField(formData, 'type', 'type', 0) ||
              $util.isShowField(formData, 'type', 'type', 1)
          "
        >
          <el-form-item
            label="优惠券面值"
            :rules="{
              required: true,
              trigger: 'blur',
              message: '优惠券面值不能为空'
            }"
            prop="value"
          >
            <el-input :min="0" type="number" v-model="formData.value"></el-input>
          </el-form-item>
        </template>
        <template v-if="$util.isShowField(formData, 'type', 'type', 2)">
          <el-form-item
            label="优惠券面值（折）"
            :rules="{
              required: true,
              trigger: 'blur',
              message: '优惠券面值不能为空'
            }"
            prop="value"
          >
            <template slot="label">
              <span>
                优惠券面值（折）
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="请输入0.01到1之间的数字"
                  placement="top-end"
                >
                  <i class="el-icon-info c-color-primary"></i>
                </el-tooltip>
              </span>
            </template>

            <el-input-number
              v-model="formData.value"
              :controls="false"
              :min="0.01"
              :precision="2"
              :max="1"
            ></el-input-number>
          </el-form-item>
        </template>

        <el-form-item
          label="使用条件"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '优惠券面值不能为空'
          }"
          prop="prerequisites"
        >
          <template slot="label">
            <span>
              使用条件
              <el-tooltip
                class="item"
                effect="dark"
                content="满足多少钱才能使用"
                placement="top-end"
              >
                <i class="el-icon-info c-color-primary"></i>
              </el-tooltip>
            </span>
          </template>
          <el-input :min="0" type="number" v-model="formData.prerequisites"></el-input>
        </el-form-item>
        <el-form-item label="用户限领取数量" prop="eachDelivery">
          <el-input v-model="formData.eachDelivery"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="formData.description"></el-input>
        </el-form-item>

        <!--  <el-form-item label="使用条件" prop="prerequisites">
          <el-select v-model="formData.prerequisites">
            <el-option v-for="item in []" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        -->
        <!--
        <el-form-item label="领取数量" prop="eachDelivery">
          <el-input type="number" v-model="formData.eachDelivery"></el-input>
        </el-form-item>
        -->
        <template v-for="(extField, idx) in extFields">
          <el-form-item
            :key="idx"
            :label="extField.nameDisp"
            v-if="extField.showList && extField.showList.indexOf('2') != -1"
          >
            <!-- pc表单展示的字段 -->
            <template>
              <template
                v-if="
                  extField.type == 'text' ||
                    extField.type == 'textarea' ||
                    extField.type == 'number'
                "
              >
                <el-input v-model="formData.exts[extField.name]" :type="extField.type"></el-input>
              </template>
              <template v-if="extField.type == 'radio'">
                <el-radio-group v-model="formData.exts[extField.name]">
                  <el-radio
                    v-for="item in options[extField.valueOption]"
                    :key="item.value"
                    :label="item.value"
                  >
                    {{ item.label }}
                  </el-radio>
                </el-radio-group>
              </template>
              <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
                <el-checkbox-group v-model="formData.exts[extField.name]">
                  <el-checkbox
                    v-for="item in options[extField.valueOption]"
                    :label="item.value"
                    :key="item.value"
                  >
                    {{ item.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </template>
              <template v-if="extField.type == 'select'">
                <el-select v-model="formData.exts[extField.name]" placeholder="请选择" clearable>
                  <el-option
                    v-for="item in options[extField.valueOption]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
              <template v-if="extField.type == 'cascade'">
                <el-cascader
                  clearable
                  v-model="formData.exts[extField.name]"
                  :options="options[extField.valueOption]"
                  :props="{ checkStrictly: true, label: 'name' }"
                ></el-cascader>
              </template>
              <template v-if="extField.type == 'time'">
                <el-time-select
                  v-model="formData.exts[extField.name]"
                  placeholder="选择时间"
                ></el-time-select>
              </template>
              <template v-if="extField.type == 'date' || extField.type == 'datetime'">
                <el-date-picker
                  v-model="formData.exts[extField.name]"
                  :type="extField.type"
                  placeholder="选择日期"
                ></el-date-picker>
              </template>
              <template v-if="extField.type == 'switch'">
                <el-switch
                  v-model="formData.exts[extField.name]"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </template>
              <template v-if="extField.type == 'rate'">
                <el-rate v-model="formData.exts[extField.name]" @change="$forceUpdate()"></el-rate>
              </template>
            </template>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="优惠券领取记录" :visible.sync="openRecordDetail">
      <div style="height: 100%; display: flex; flex-direction: column">
        <div style="height: 100%; display: flex; flex-direction: column">
          <div style="min-height: 400px; flex: 1">
            <div style="margin: 10px 0">
              <el-input
                placeholder="请输入优惠券标题/券号"
                style="width: 260px"
                v-model="searchRecordValue"
                clearable
                @clear="
                  recordFpi.page = 1;
                  doRecord(couponId);
                "
                @keyup.enter.native="
                  recordFpi.page = 1;
                  doRecord(couponId);
                "
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="
                    fpi.page = 1;
                    doRecord(couponId);
                  "
                ></el-button>
              </el-input>
            </div>
            <el-table
              ref="recordTable"
              height="calc(100% - 80px)"
              :data="recordFpi.data"
              v-if="recordFpi.data && recordFpi.data.length && extFieldsCouponPrinting.length"
            >
              <c-table :fields="extFieldsCouponPrinting"></c-table>
            </el-table>
          </div>
        </div>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="recordFpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="recordFpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="recordFpi.total"
        ></el-pagination>
      </div>

      <div slot="footer">
        <el-button
          type="primary"
          @click="
            openRecordDetail = false;
            couponId = '';
          "
        >
          关 闭
        </el-button>
        <!-- <el-button @click="doInit">取 消</el-button> -->
      </div>
    </el-dialog>

    <el-dialog title="分配优惠券" :visible.sync="distributeData.openDetail">
      <el-form
        :model="distributeData.formData"
        ref="distributeDataForm"
        label-width="160px"
        label-position="left"
        hide-required-asterisk:true
      >
        <el-form-item
          label="选择客户"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '选择客户不能为空'
          }"
          prop="contactId"
        >
          <el-select
            v-model="distributeData.formData.contactId"
            :remote-method="querySearch"
            filterable
            remote
            placeholder="可搜索人员姓名/手机"
            size="small"
            style="width:100%"
            @change="distributeContactChange"
          >
            <el-option
              v-for="(item, i) in options.contacts"
              :key="i"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item
          label="客户手机号"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '客户手机号不能为空'
          }"
          prop="phone"
        >
          <el-input :min="0" type="number" v-model="distributeData.formData.phone"></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer">
        <el-button @click="distributeData.openDetail = false">
          关 闭
        </el-button>
        <el-button type="primary" @click="doSaveDistributeData">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'coupons',
  data() {
    return {
      name: 'coupons',
      refresh: true,
      pickerOptions: {
        shortcuts: [
          {
            text: '一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        timeRange: [], //活动有效区间
        durationTimeRange: [] //券有效区间
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_state: { codeId: 'state' },
        codecfg_couponType: { codeId: 'couponType' },
        codecfg_CpsDiscountType: { codeId: 'CpsDiscountType' }
      },
      //产品列表
      ProductsList: [],
      isEdit: false, //编辑为true,新增为false
      openRecordDetail: false, //优惠券领取记录弹出
      extFieldsCouponPrinting: [], //优惠券扩展字段
      recordFpi: {
        //优惠券领取记录
        data: []
      },
      couponId: '', //用于查询优惠券记录的活动id
      searchRecordValue: '', //优惠券过滤条件
      distributeData: { formData: {}, openDetail: false } //分配优惠券对象
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  mounted() {
    this.doInit();
    this.osg.ajax(
      'biz/extField/query.do',
      {
        colName: 'coupon',
        _all: '1',
        'is:state|integer#and': 1,
        'nin:preset|array-integer#and': 1,
        sortField: 'order',
        sortOrder: 'asc'
      },
      res => {
        this.extFields = res.data;
        this.options = this.options || [];
        //扩展字段选项关联字典表的查询出选项数据
        for (var item of res.data) {
          if (item.valueOption) {
            this.options['codecfg_' + item.valueOption] = {
              codeId: item.valueOption
            };
          }
          //级联
          if (item.type == 'cascade')
            this.options['cascadeCode_' + item.valueOption] = {
              codeId: item.valueOption
            };
        }
        //优惠券领取对象
        this.getCouponPrintingExt(() => {
          this.osg.codeoption(() => {
            this.osg.getFpi();
            this.getData();
            this.getProductsData();
          });
        });
      },
      { noload: true }
    );
  },
  methods: {
    formatState(row, column, cellValue, index) {
      // return this.osg.codelabel("state", cellValue);
      if (cellValue == 0) return '无效';
      else if (cellValue == 1) return '有效';
      else return '未知';
    },
    formatterCouponType(row, column, cellValue, index) {
      return this.osg.codelabel('couponType', cellValue);
    },
    formatterCpsDiscountType(row, column, cellValue, index) {
      return this.osg.codelabel('CpsDiscountType', cellValue);
    },
    formatterProductsList(row, column, cellValue, index) {
      let label = this.ProductsList.map(item => {
        if (item.value == cellValue) {
          return item.label;
        }
      }).join('');
      return label;
    },
    //优惠券领取对象
    getCouponPrintingExt(callback) {
      this.osg.ajax(
        'biz/extField/query.do',
        {
          colName: 'couponPrinting',
          _all: '1',
          'is:state|integer#and': 1,
          // 'nin:preset|array-integer#and': 1,
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          this.extFieldsCouponPrinting = res.data;
          this.options = this.options || [];
          //扩展字段选项关联字典表的查询出选项数据
          for (var item of res.data) {
            if (item.valueOption) {
              this.options['codecfg_' + item.valueOption] = {
                codeId: item.valueOption
              };
            }
            //级联
            if (item.type == 'cascade')
              this.options['cascadeCode_' + item.valueOption] = {
                codeId: item.valueOption
              };
          }
          if (callback) callback();
        },
        { noload: true }
      );
    },
    // 获取用户列表
    getUsers(name) {
      this.osg.ajax(
        'user/query.do',
        {
          page: 1,
          rows: 20,
          'regex:name|string#and': name
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.users = res.data;
        },
        {
          noload: true
        }
      );
    },
    //查询客户
    querySearch(queryString, cb) {
      var params = {
        page: 1,
        rows: 20,
        sortField: 'createTime',
        sortOrder: 'desc',
        'regex:name|string#or': queryString,
        'regex:phone|string#or': queryString
      };
      this.osg.ajax(
        'basic/contacts/query.do',
        params,
        res => {
          this.$set(this.options, 'contacts', res.data);
          cb(res.data);
        },
        { noload: true }
      );
    },
    //创建优惠券领取记录
    doSaveDistributeData() {
      // if (!this.distributeData.formData.phone){
      //   this.osg.toast('请选择客户','warning');
      //   return;
      // }
      // 'distributeDataForm'
      // debugger;
      if (this.osg.validate('distributeDataForm')) {
        this.osg.ajax(
          'basic/couponPrinting/upsert.do',
          this.distributeData.formData,
          () => {
            this.distributeData.openDetail = false;
            this.osg.toast('操作成功！');
          },
          {
            noload: true
          }
        );
      }
    },
    //分配优惠券-更改客户
    distributeContactChange(contactId) {
      this.distributeData.formData.phone = this.options.contacts.find(
        item => item._id == contactId
      ).phone;
    },
    getProductsData() {
      let params = {
        // page: this.fpi.page,
        // rows: this.fpi.rows,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('basic/product/query.do', params, res => {
        res.data.map(item => {
          if (this.$util.isJson(item.image)) {
            item.image = JSON.parse(item.image);
          }
          item.label = item.name;
          item.value = item._id;
        });
        this.ProductsList = res.data;
      });
    },
    pageSizeChange(pageSize) {
      if (this.openRecordDetail) {
        this.recordFpi.rows = pageSize;
        this.doRecord(this.couponId);
      } else {
        this.fpi.rows = pageSize;
        this.getData();
      }
    },
    pageChange(currentPage) {
      if (this.openRecordDetail) {
        this.recordFpi.page = currentPage;
        this.doRecord(this.couponId);
      } else {
        this.fpi.page = currentPage;
        this.getData();
      }
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:title|string#or': this.searchValue,
        'regex:_id|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.setFpi(params);
      this.osg.ajax('/basic/coupon/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    //查看领取记录
    doRecord(couponId) {
      this.couponId = couponId;
      if (!couponId) return;
      var params = {
        page: this.recordFpi.page || 1,
        rows: this.recordFpi.rows || 20,
        'is:couponId|string#or': couponId,
        'regex:title|string#or': this.searchRecordValue,
        'is:_id|string#or': this.searchRecordValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('/basic/couponPrinting/query.do', params, res => {
        this.recordFpi = res;
        console.log(this.recordFpi, this.extFieldsCouponPrinting);
        this.$nextTick(() => {
          // this.$refs.recordTable.doLayout();
          // this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.isEdit = false;
      this.openDetail = true;
    },
    doEdit(row) {
      this.isEdit = true;
      row = this.$util.deepCopy(row);
      row.type = String(row.type);
      if (row.startDate && row.endDate) row.timeRange = [row.startDate, row.endDate];
      if (row.startCouponDate && row.endCouponDate)
        row.durationTimeRange = [row.startCouponDate, row.endCouponDate];
      this.$util.renderExtField(this.extFields, row);
      console.log(row);
      this.formData = row;
      this.openDetail = true;
    },
    //修改发行量
    doStock(id) {
      this.$prompt('请输入数字，正数加库存数量，负数将会减少库存数量', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^-?\d+$/,
        inputErrorMessage: '请输入整数',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(({ value }) => {
          this.osg.ajax('basic/coupon/upsertRedis.do', { id, count: value, flag: 0 }, res => {
            this.doInit();
            this.getData();
            this.osg.toast('操作成功！');
          });
        })
        .catch(() => {
          //   this.osg.toast('取消审核', 'info');
        });
    },
    doSave() {
      this.$util.saveExtField(this.extFields, this.formData);
      if (this.osg.validate()) {
        this.formData.exts = this.formData.exts || {};
        if (this.formData.timeRange) {
          this.formData.startDate = this.formData.timeRange[0];
          this.formData.endDate = this.formData.timeRange[1];
          this.formData.exts.startDate = this.formData.startDate.substr(
            0,
            this.formData.startDate.indexOf(' ')
          );
          this.formData.exts.endDate = this.formData.endDate.substr(
            0,
            this.formData.endDate.indexOf(' ')
          );
          delete this.formData.timeRange;
          // let startDate = new Date(this.formData.timeRange[0]).getTime();
          // let nowDate = new Date().valueOf();
          // // 当选择的开始时间大于现在的时间，这个优惠券未激活状态
          // if (startDate > nowDate) this.formData.state = 2;
        }
        if (this.formData.durationTimeRange) {
          this.formData.startCouponDate = this.formData.durationTimeRange[0];
          this.formData.endCouponDate = this.formData.durationTimeRange[1];
          this.formData.exts.startCouponDate = this.formData.startCouponDate.substr(
            0,
            this.formData.startCouponDate.indexOf(' ')
          );
          this.formData.exts.endCouponDate = this.formData.endCouponDate.substr(
            0,
            this.formData.endCouponDate.indexOf(' ')
          );
          delete this.formData.durationTimeRange;
        }

        if (!this.isEdit) this.formData.stock = this.formData.quantity;
        if (!this.formData._id) this.formData.stock = 0;
        this.osg.ajax('basic/coupon/upsert.do', this.formData, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    //分配优惠券
    doDistribute(row) {
      this.distributeData.openDetail = true;
      this.distributeData.formData.couponId = row._id;
    },
    doEnable(id) {
      this.osg.ajax('basic/coupon/enable/' + id + '.do', null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/coupon/disable/' + id + '.do', null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        let that = this;
        that.osg.ajax(`basic/coupon/remove/${id}.do`, null, res => {
          that.osg.toast('删除成功');
          that.getData();
        });
      });
    }
  }
};
</script>
